var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "new-bill-payment-dialog",
          attrs: {
            visible: _vm.step1Visible,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            width: "1150px",
            title: _vm.title,
            top: "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.step1Visible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              !_vm.isQueryJob
                ? _c("native-query-charge-for-pay-apply", {
                    ref: "queryCharge",
                    attrs: {
                      "show-simple": false,
                      identify: "queryCharge",
                      "view-source": "billPaymentByJob_Create_Charge",
                      "has-bill-payment": 0,
                      "charge-state-param": "BillPaymentChargeState",
                      "confirm-state-param": "BillPaymentChargeConfirmState",
                      "job-state-param": "BillPaymentJobState",
                      "is-ar": _vm.defaultSearchConditions.isAr,
                      "show-charge-count": _vm.showWindow,
                      "check-verified-amount": true,
                      "show-controlled-charge": false,
                      "is-show-write-off": false,
                      "new-by-job": 2,
                      "internal-charge":
                        _vm.defaultSearchConditions.internalCharge,
                      "config-module": "5804",
                      "grid-config-module": "580401"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "searchAreaHeader",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "app-main-inner-row  extension-conditions-form"
                                },
                                [
                                  _c("div", { staticClass: "filters" }, [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { margin: "7px" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Payment.inquiryWay")
                                              )
                                            )
                                          ]
                                        ),
                                        [
                                          _c(
                                            "el-form",
                                            { attrs: { inline: "" } },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      on: {
                                                        change:
                                                          _vm.onQueryTypeChange
                                                      },
                                                      model: {
                                                        value: _vm.queryType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.queryType = $$v
                                                        },
                                                        expression: "queryType"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: "charge"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Payment.accordingToCharge"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: "job"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Payment.accordingToBusiness"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        "true-label": -1,
                                                        "false-label": 0
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .defaultSearchConditions
                                                            .isAr,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.defaultSearchConditions,
                                                            "isAr",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "defaultSearchConditions.isAr"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Payment.includeReceivables"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.useOrderCenterMode,
                                                      expression:
                                                        "useOrderCenterMode"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm
                                                            .defaultSearchConditions
                                                            .internalCharge,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.defaultSearchConditions,
                                                            "internalCharge",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "defaultSearchConditions.internalCharge"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_InternalCharges"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#ff0000",
                                              margin: "7px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1862814228
                    )
                  })
                : _vm._e(),
              _vm.isQueryJob
                ? _c("query-job-fast-for-pay-apply", {
                    ref: "queryJob",
                    attrs: {
                      "show-simple": false,
                      identify: "queryJob",
                      "view-source": "billPayment_Create_Job",
                      "total-data-field": "chargeAmount",
                      "total-currency-field": "chargeCurrency",
                      "charge-state-param": "BillPaymentChargeState",
                      "confirm-state-param": "BillPaymentChargeConfirmState",
                      "job-state-param": "BillPaymentJobState",
                      "is-ar": _vm.defaultSearchConditions.isAr,
                      "has-bill-payment": 0,
                      "show-charge-count": _vm.showWindow,
                      "show-controlled-charge": false,
                      "new-by-job": 1,
                      "is-show-write-off": false,
                      "internal-charge":
                        _vm.defaultSearchConditions.internalCharge,
                      "config-module": "5083",
                      "grid-config-module": "50830101"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "searchAreaHeader",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "app-main-inner-row  extension-conditions-form"
                                },
                                [
                                  _c("div", { staticClass: "filters" }, [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { margin: "7px" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Payment.inquiryWay")
                                              )
                                            )
                                          ]
                                        ),
                                        [
                                          _c(
                                            "el-form",
                                            { attrs: { inline: "" } },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      on: {
                                                        change:
                                                          _vm.onQueryTypeChange
                                                      },
                                                      model: {
                                                        value: _vm.queryType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.queryType = $$v
                                                        },
                                                        expression: "queryType"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: "charge"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Payment.accordingToCharge"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: "job"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Payment.accordingToBusiness"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        "true-label": -1,
                                                        "false-label": 0
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .defaultSearchConditions
                                                            .isAr,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.defaultSearchConditions,
                                                            "isAr",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "defaultSearchConditions.isAr"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Payment.includeReceivables"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.useOrderCenterMode,
                                                      expression:
                                                        "useOrderCenterMode"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm
                                                            .defaultSearchConditions
                                                            .internalCharge,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.defaultSearchConditions,
                                                            "internalCharge",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "defaultSearchConditions.internalCharge"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_InternalCharges"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#ff0000",
                                              margin: "7px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1862814228
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.nextStep }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.next")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("Payment.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: {
          visible: _vm.step2Visible,
          title: _vm.billPaymentDialog.title,
          "open-sap-config": _vm.openSapConfig,
          location: _vm.location,
          "view-source": "billPayment_Create_Job"
        },
        on: {
          "update:visible": function($event) {
            _vm.step2Visible = $event
          },
          toPreStep: _vm.toPreStep,
          cancel: _vm.cancel,
          reloadData: _vm.reloadData
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }